// upload.component.ts
import { Component, ViewChild, HostListener, Inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { MAT_DIALOG_DATA as MAT_DIALOG_DATA, MatDialogRef as MatDialogRef } from '@angular/material/dialog';
import Swal from 'sweetalert2';
import { ApiService } from 'src/app/api/api.service';

@Component({
    selector: 'app-file-upload',
    templateUrl: './file-upload-v2.component.html',
    styleUrls: ['./file-upload-v2.component.css'],
    standalone: false
})
export class FileUploadV2Component {
  @ViewChild('fileInput') fileInput: any;
  selectedFile: File = null as any;
  fileName: string = '';
  fd = new FormData();
  isDragOver: boolean = false;

  Comment = ''
  isLoading = false

  constructor(private http: HttpClient, private api: ApiService, public dialog: MatDialogRef<FileUploadV2Component>,  
    @Inject(MAT_DIALOG_DATA) public data: any) { }

  @HostListener('dragover', ['$event']) onDragOver(event: any) {
    event.preventDefault();
    this.isDragOver = true;
  }

  @HostListener('dragleave', ['$event']) onDragLeave(event: any) {
    event.preventDefault();
    this.isDragOver = false;
  }

  @HostListener('drop', ['$event']) onDrop(event: any) {
    event.preventDefault();
    this.isDragOver = false;
    this.selectedFile = <File>event.dataTransfer.files[0];
    this.fileName = this.selectedFile?.name || '';
  }

  onFileSelected(event: any) {
    this.selectedFile = <File>event.target.files[0];
    this.fileName = this.selectedFile?.name || '';
  }
  
  onUpload() {
    this.fileInput.nativeElement.click();
  }
  
  sendFile() {
    this.isLoading = true;

    if (!this.Comment.trim()) {
      Swal.fire({
        icon: 'warning',
        title: 'Comentario requerido',
        text: 'Debe ingresar un comentario antes de autorizar.'
      });
      this.isLoading = false;
      return;
    }

    if (!this.selectedFile) {
      Swal.fire({
        icon: 'warning',
        title: 'Documento requerido',
        text: 'Debe cargar un documento antes de autorizar.'
      });
      this.isLoading = false;
      return;
    }

    const fd = new FormData();
    fd.append('file', this.selectedFile, this.selectedFile.name);

    let new_ticket = this.data.ticket;
    new_ticket.comment = `Se autorizó la excepción: ${this.Comment}`;
    let params = { "user_logged_in": this.data.user_id, "case_id": this.data.case_id };

    this.api.uploadFiles.uploadPDF(fd, params).promise().then((response: any) => {
      if (response && response.success) {
        new_ticket.exception_attachment_id = response.attachment_id;
        new_ticket.exception_attachement_id = response.attachment_id;
        new_ticket.exception_authorizer_id = this.data.user_id;
        this.api.assistancetickets.create(new_ticket).promise().then(resp => {
          Swal.fire({
            icon: 'success',
            title: 'Archivo subido',
            text: 'Se ha autorizado la Excepción',
            showConfirmButton: true,
            showDenyButton: false
          })
          .then((result) => {
            if (result.isConfirmed) {
              this.dialog.close(resp);
            }
          });
        });
      } else {
        Swal.fire({
          icon: 'error',
          title: 'Error',
          text: response?.message || 'Ha ocurrido un error al subir el archivo'
        }).then(() => {
          this.dialog.close();
        });
      }
    }).catch(err => {
      Swal.fire({
        icon: 'error',
        title: 'Error',
        text: 'Ha ocurrido un error al subir el archivo'
      }).then(() => {
        this.dialog.close();
      });
    }).finally(() => {
      this.isLoading = false;
    });
  }
}